var _module_exports ="<!--\n  This file didn't exist in previous project.\n  This is a placeholder to avoid \"Can't resolve xxx\" error.\n-->\n";;
var path = '/app/Main/procedure/procedureResponsibilityEdit.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;